import { Currency } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React, { useCallback, useState } from 'react';

import { PlayMoney } from '@swf/account';
import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import { Alert } from '@swf/first';

import { TXTWCL_N0_Play_Chips_have_been_added__ELL } from './PlayMoneySection.messages.json';

const PlayMoneySection: React.FC = () => {
  const [refilledAmount, setRefilledAmount] = useState(0);

  const collectionCallback = useCallback((amount: number) => {
    setRefilledAmount(amount);
  }, []);

  return (
    <>
      {!!refilledAmount && (
        <Alert variant="success">
          <Translation
            values={{
              0: <CurrencyAmount value={refilledAmount} currency={Currency.PlayMoney} />
            }}
            {...TXTWCL_N0_Play_Chips_have_been_added__ELL}
          />
        </Alert>
      )}
      <PlayMoney collectionCallback={collectionCallback} walletIntegration />
    </>
  );
};

export default PlayMoneySection;
